import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetS3RagPathUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (filename: string, customer: any): Promise<any> => {
        console.log(filename, customer);
        
        return await this._aiRepository.getAIS3RagPath(filename, customer);
    }
}

export const GetS3RagPathUseCaseName = "GetS3RagPathUseCaseName";